module.exports = __webpack_public_path__ + "static/media/first-aid.1a35e4f2.svg";